/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/no-danger */
import React, { useContext, useEffect, useState } from 'react';
import { gql, useQuery } from '@apollo/client';
import parse from 'html-react-parser';
import { ArtistContext } from 'context/ArtistContext';
import { MemberType, NavigationContactInfo } from 'types';
import { Link, useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import {
  faInstagram,
  faFacebook,
  faTiktok,
  faTwitter,
  faYoutube,
  faLinkedin,
  faSpotify,
  faSoundcloud,
} from '@fortawesome/free-brands-svg-icons';
import {
  faEnvelope,
  faArrowLeft,
  faGlobe,
  faDownload,
  faLocationDot,
  faPhone,
  faDiamondTurnRight,
} from '@fortawesome/free-solid-svg-icons';
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectCards } from 'swiper';
import Footer from 'components/footer/Footer';
import Nav from 'components/nav/Nav';
import InstagramSection from 'components/instagramSection/InstagramSection';
import Loader from '../../components/loader/Loader';
import { Head } from '../../components/Head';
import 'swiper/css';
import 'swiper/css/effect-cards';
import './artist-page.scss';

const GET_MEMBER = gql`
  query GET_MEMBER {
    teamMembers(first: 100) {
      createdAt
      name
      instrument
      spotifyLink
      websiteLink
      memberSlug
      miniMemberBio
      tikTokLink
      companyTitle
      fullBio {
        html
      }
      avatarImage {
        url
      }
      instagramLink
      email
      calendlyLink
      phoneNumber
      facebookLink
      soundcloudLink
      pandoraLink
      epkLink
      youtubeLink
      twitterLink
      linkedinLink
      memberBandsInTown
      memberImageGallery(first: 100) {
        url
      }
      memberMusicRelease(first: 100) {
        url
      }
      memberBookingData
      contactList {
        contactName
        contactEmail
        contactTitle
        contactPhone
        contactAddress
        contactGoogleAddressLink
        contactAvatar {
          id
        }
      }
      videoBox {
        videoTitle
        youtubeVideoId
        vimeoVideoId
        youtubePlaylistId
      }
      primaryMember
      memberHeroImage {
        url
      }
      memberIFrame
      order
      memberType
    }
  }
`;

export default function ArtistPage() {
  const [isScrolled, setIsScrolled] = useState<boolean>(false);
  const stickyCallBak = () => {
    const scrollTop = window.scrollY;
    scrollTop >= 150 ? setIsScrolled(true) : setIsScrolled(false);
  };
  useEffect(() => {
    window.addEventListener('scroll', stickyCallBak);

    return () => {
      window.removeEventListener('scroll', stickyCallBak);
    };
  });
  const { memberPageUrlParam } = useParams();
  const { memberTypeParam } = useParams();
  console.log('artistPageUrlParam', memberPageUrlParam);
  console.log('artistPageUrlParam', memberTypeParam);
  const { loading, data } = useQuery(GET_MEMBER);
  const artist = useContext(ArtistContext);
  if (!artist) return <div />;
  const { logo, isSpanish } = artist;
  const { teamMembers } = data;
  if (loading) return <Loader height="60vh" />;

  const talent: MemberType = teamMembers.find(
    (talent: MemberType) => talent.memberSlug === memberPageUrlParam,
  );

  console.log(talent as MemberType);

  return (
    <>
      <Head metaTitle={talent.name} />
      <Nav />
      <section className="container">
        <div className="w-full mx-auto text-center my-2 md:mt-0 mb-2">
          <Link
            to={`/1/${memberTypeParam}`}
            className="text-link uppercase no-underline justify-content-center max-w-max">
            <FontAwesomeIcon
              icon={faArrowLeft as IconProp}
              className="fa-fw mr-2"
            />
            <span>{isSpanish ? 'Todos Artistas' : 'All Artists'}</span>
          </Link>
        </div>
        <div
          className={`col-12 mx-auto animate-col-width ${
            isScrolled ? 'md:col-7' : 'md:col-6'
          }`}
          key={talent?.avatarImage?.url || Math.random()}>
          <div className="member-card">
            <div className="relative">
              {!!talent.primaryMember && (
                <p className="talent-primary-badge">
                  {isSpanish ? 'Exclusivo' : 'Exclusive'}
                </p>
              )}
              {!!talent?.avatarImage && (
                <img
                  src={talent.avatarImage.url}
                  alt={(talent.name && talent.name) || ''}
                  className="block"
                  style={{
                    height: isScrolled ? '650px' : '625px',
                    transition: 'height 200ms ease-in-out',
                  }}
                />
              )}
            </div>
            <div className="member-card-content w-11 mx-auto">
              {!!talent.name && (
                <h1 className="uppercase mb-2 gradient-text">{talent.name}</h1>
              )}
              {!!talent?.instrument && (
                <p className="text-sm mt-0 py-0 mb-0">{talent.instrument}</p>
              )}
              {!!talent?.miniMemberBio && (
                <p className="text-sm mt-0 py-0 mb-2 text-center uppercase">
                  {talent.miniMemberBio}
                </p>
              )}
              <nav className="member-card-social-icons mx-auto block max-w-max px-0 mt-1 mb-3">
                <div className="flex flex-row align-items-center mb-1">
                  {!!talent.instagramLink && (
                    <a
                      href={talent.instagramLink}
                      target="_blank"
                      className="max-w-max mr-2 text-center ml-0"
                      rel="noreferrer">
                      <FontAwesomeIcon
                        icon={faInstagram as IconProp}
                        className="fa-fw"
                      />
                    </a>
                  )}
                  {!!talent.facebookLink && (
                    <a
                      href={talent.facebookLink}
                      target="_blank"
                      className="max-w-max mr-2 ml-0"
                      rel="noreferrer">
                      <FontAwesomeIcon
                        icon={faFacebook as IconProp}
                        className="fa-fw"
                      />
                    </a>
                  )}
                  {!!talent.twitterLink && (
                    <a
                      href={talent.twitterLink}
                      target="_blank"
                      className="max-w-max mr-2 ml-0"
                      rel="noreferrer">
                      <FontAwesomeIcon
                        icon={faTwitter as IconProp}
                        className="fa-fw"
                      />
                    </a>
                  )}
                  {!!talent.youtubeLink && (
                    <a
                      href={talent.youtubeLink}
                      target="_blank"
                      className="max-w-max mr-2 ml-0"
                      rel="noreferrer">
                      <FontAwesomeIcon
                        icon={faYoutube as IconProp}
                        className="fa-fw"
                      />
                    </a>
                  )}
                  {!!talent.tikTokLink && (
                    <a
                      href={talent.tikTokLink}
                      target="_blank"
                      className="max-w-max mr-2 ml-0"
                      rel="noreferrer">
                      <FontAwesomeIcon
                        icon={faTiktok as IconProp}
                        className="fa-fw"
                      />
                    </a>
                  )}
                  {!!talent.soundcloudLink && (
                    <a
                      href={talent.soundcloudLink}
                      target="_blank"
                      className="max-w-max mr-2 ml-0"
                      rel="noreferrer">
                      <FontAwesomeIcon
                        icon={faSoundcloud as IconProp}
                        className="fa-fw"
                      />
                    </a>
                  )}
                  {!!talent.linkedinLink && (
                    <a
                      href={talent.linkedinLink}
                      target="_blank"
                      className="max-w-max mr-2 ml-0"
                      rel="noreferrer">
                      <FontAwesomeIcon
                        icon={faLinkedin as IconProp}
                        className="fa-fw"
                      />
                    </a>
                  )}
                  {!!talent.email && (
                    <a
                      href={`mailto:${talent.email}`}
                      target="_blank"
                      className="max-w-max mr-2 ml-0"
                      rel="noreferrer">
                      <FontAwesomeIcon
                        icon={faEnvelope as IconProp}
                        className="fa-fw"
                      />
                    </a>
                  )}
                  {!!talent.spotifyLink && (
                    <a
                      href={talent.spotifyLink}
                      target="_blank"
                      className="max-w-max mr-2 ml-0"
                      rel="noreferrer">
                      <FontAwesomeIcon
                        icon={faSpotify as IconProp}
                        className="fa-fw"
                      />
                    </a>
                  )}
                  {!!talent.websiteLink && (
                    <a
                      href={talent.websiteLink}
                      target="_blank"
                      className="max-w-max mr-2 ml-0"
                      rel="noreferrer">
                      <FontAwesomeIcon
                        icon={faGlobe as IconProp}
                        className="fa-fw"
                      />
                    </a>
                  )}
                  {!!talent.epkLink && (
                    <a
                      href={talent.epkLink}
                      target="_blank"
                      className="max-w-max mr-2 ml-0"
                      rel="noreferrer">
                      <FontAwesomeIcon
                        icon={faDownload as IconProp}
                        className="fa-fw"
                      />
                    </a>
                  )}
                </div>
                <div className="">
                  {/* {!!talent.phoneMemberLink && (
                    <a
                      href={`tel:${talent.phoneMemberLink}`}
                      target="_blank"
                      className="max-w-max mr-2 ml-0"
                      rel="noreferrer">
                      <FontAwesomeIcon
                        icon={faPhone as IconProp}
                        className="fa-fw"
                      />
                      <span className="ml-2">{talent.phoneMemberLink}</span>
                    </a>
                  )} */}
                  {/* {!!memberBookingData.contactItems.map(memberBookingItem => (
                    <p>{}</p>
                  ))} */}
                </div>
              </nav>

              {talent?.memberBookingData?.contactItems.map(
                (contactItem: NavigationContactInfo) => (
                  <div className="grid w-full flex align-items-center justify-content-center">
                    <div className="col-12 flex align-items-center flex-column">
                      {!!contactItem.name && (
                        <h4 className="font-bold text-xl m-0 flex flex-column align-items-center text-center justify-content-center mb-2">
                          <span className="block mx-auto">
                            {contactItem.name}
                          </span>
                          <span className="opacity-70 block text-xs mx-auto uppercase">
                            {contactItem.title}
                          </span>
                        </h4>
                      )}
                      {!!contactItem.email && (
                        <p className="flex align-items-center mt-0 mb-2">
                          <FontAwesomeIcon
                            icon={faEnvelope as IconProp}
                            className="fa-fw mr-2"
                          />
                          <span>{contactItem.email}</span>
                        </p>
                      )}
                      {!!contactItem.phone && (
                        <p className="flex align-items-center mt-0 mb-2">
                          <FontAwesomeIcon
                            icon={faPhone as IconProp}
                            className="fa-fw mr-2"
                          />
                          <span>{contactItem.phone}</span>
                        </p>
                      )}
                      {!!contactItem.address && (
                        <div className="flex flex-row align-items-center">
                          <p>
                            <FontAwesomeIcon
                              icon={faLocationDot as IconProp}
                              className="fa-fw mr-2"
                            />
                          </p>
                          <p className="flex flex-column">
                            <span>{contactItem.address}</span>
                            <span>{contactItem.cityStateZip}</span>
                          </p>
                          <a
                            href={contactItem.googleAddressLink}
                            className="text-primary"
                            target="_blank"
                            rel="noreferrer">
                            <FontAwesomeIcon
                              icon={faDiamondTurnRight as IconProp}
                              className="fa-fw ml-2"
                            />
                          </a>
                        </div>
                      )}
                    </div>
                    {!!contactItem.imageOne && (
                      <div className="col-12 md:col-6 animate-col-width">
                        <img
                          src={contactItem.imageOne}
                          alt=""
                          className="block w-12 border-round mb-4
                            "
                        />
                      </div>
                    )}
                  </div>
                ),
              )}

              {!!talent.fullBio?.html && (
                <p className="body-parsed-text text-sm mt-0 py-0 mb-2">
                  {parse(talent.fullBio.html)}
                </p>
              )}
              {!!talent?.memberImageGallery && (
                <Swiper
                  effect="cards"
                  grabCursor
                  modules={[EffectCards]}
                  className="album-swiper my-8">
                  {talent.memberImageGallery?.map(memberImageGalleryItem => (
                    <SwiperSlide
                      key={memberImageGalleryItem.url}
                      className=""
                      style={{ transform: 'scale(0.975)' }}>
                      <img
                        src={memberImageGalleryItem.url}
                        alt=""
                        className="mb-0 block border-round"
                        style={{
                          maxHeight: '1000px',
                          objectFit: 'cover',
                          aspectRatio: 1,
                        }}
                      />
                    </SwiperSlide>
                  ))}
                </Swiper>
              )}
              {!!talent.memberBandsInTown && (
                <section className="container my-4 dark-section">
                  {/* <h2 className="text-3xl md:text-6xl my-2 text-center">
                    {tourSectionTitle && tourSectionTitle}
                  </h2> */}
                  {parse(talent.memberBandsInTown)}
                </section>
              )}
              {!!talent?.instagramLink && (
                <InstagramSection IGUsername={talent.instagramLink} />
              )}
            </div>
          </div>
        </div>
      </section>
      {/* {!!homeStandoutText && (
        <div
          className={`home-standout-text-wrapper gradient-bkg my-8 ${
            homeStandoutTextCssWrapperName && homeStandoutTextCssWrapperName
          }`}>
          <section className="container py-8 flex align-items-center justify-content-center">
            <h3 className="home-standout-text text-center w-10 md:w-6 mx-auto">
              {homeStandoutText}
            </h3>
          </section>
        </div>
      )} */}
      {!!teamMembers && (
        <section className="container my-8 px-4">
          <div className="grid">
            <div className="col-12 lg:col-2 flex flex-column align-items-center justify-items-center lg:justify-content-start">
              <img
                src={logo?.url}
                alt=""
                className="w-6 md:w-5 lg:w-8 block animate-col-width "
              />
              {/* <p>{talentSectionTitle}</p> */}
            </div>
            <div className="col-12 lg:col-10 grid animate-col-width ">
              {teamMembers.map((talent: MemberType) => (
                <Link
                  to={`/1/${memberTypeParam}/${talent.memberSlug}`}
                  className="talent-card col-12 md:col-6 lg:col-4 animate-col-width  no-underline flex align-items-center justify-content-center flex-column"
                  key={talent.memberSlug}>
                  <img
                    src={talent.avatarImage?.url}
                    alt=""
                    className="mini-avatar block mx-auto"
                    style={{
                      objectFit: 'cover',
                      aspectRatio: 1,
                      height: '220px',
                      width: '220px',
                      borderRadius: '50%',
                      transition: 'all 200ms ease',
                    }}
                  />
                  {!!talent?.name && (
                    <p className="text-center mx-auto uppercase">
                      {talent.name}
                    </p>
                  )}
                </Link>
              ))}
            </div>
          </div>
        </section>
      )}
      <Footer />
    </>
  );
}
